import KeenSlider from 'keen-slider';

export default function () {
  $('.cars-carousel').each(function () {
    const key = $(this).data('key');
    const scrollBarWidth = $(this).parent().find('.scroll-bar').width();
    const thumb = $(this).parent().find('.helper-scroll-thumb');
    const thumbWidth = thumb.width();
    const ranger = $(this).parent().find(`#range-${key}`);
    const emptyBarSpace = scrollBarWidth - thumbWidth;

    $(
      `<style type='text/css'> #range-${key}::-webkit-slider-thumb { width: ${thumbWidth}px }</style>`
    ).appendTo('head');

    const navigation = (slider) => {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach(() =>
          ranger.val(slider.track.details.progress * 1000)
        );
      });

      const slide = $(this).find('.keen-slider__slide')[0];

      if (slide) {
        observer.observe(slide, {
          attributes: true,
          attributeFilter: ['style'],
        });
      }

      let dragOrigin = null;
      ranger.on('mousedown', function (e) {
        e.preventDefault();
        dragOrigin = {
          x: e.clientX,
          val: +ranger.val(),
        };
      });
      $(document)
        .on('mouseup', function () {
          dragOrigin = null;
          slider.moveToIdx(slider.track.details.rel);
        })
        .on('mousemove', function (e) {
          if (dragOrigin == null) return;
          e.preventDefault();
          const offsetX = e.clientX - dragOrigin.x;
          const offsetVal = offsetX / emptyBarSpace;
          const progress = dragOrigin.val / 1000 + offsetVal;
          if (progress > 1 || progress < 0) return;
          slider.track.to(progress * slider.track.details.length);
        });
    };

    new KeenSlider(
      this,
      {
        slides: {
          perView: 3,
          spacing: 24,
        },
        rubberband: false,
      },
      [navigation]
    );
  });
}
